import React, { useState } from "react";
import { Plus, Minus } from "lucide-react";

export default function FaqAccordion({ items }) {
  const [open, setOpen] = useState(0);
  return (
    <div className="divide-y divide-charcoal/12 border-y border-charcoal/12" data-testid="faq-accordion">
      {items.map((it, i) => (
        <div key={i} className="py-2">
          <button
            type="button"
            onClick={() => setOpen(open === i ? -1 : i)}
            className="w-full flex items-center justify-between text-left py-4 gap-6"
            aria-expanded={open === i}
            data-testid={`faq-item-${i}`}
          >
            <span className="font-serif text-lg md:text-xl text-charcoal">{it.q}</span>
            <span className="text-burgundy shrink-0">{open === i ? <Minus size={18} /> : <Plus size={18} />}</span>
          </button>
          {open === i && (
            <div className="pb-5 text-charcoal/75 leading-relaxed max-w-3xl">{it.a}</div>
          )}
        </div>
      ))}
    </div>
  );
}
